<template>
    <div class="max-w-[95%] mx-auto px-5 py-8 grid gap-10 grid-cols-1 xl:grid-cols-[350px_1fr]">

        <!-- Left Sidebar -->
        <SideBar :loading="loadLocation" :categories="categories" :location="location" @filtersChanged="filtersChanged" @filtersInitialize="filtersInitialize"></SideBar>

        <!-- Main Content -->
        <Main :events="events" :loading="loadEvents"></Main>

    </div>

</template>
<script setup>

import SideBar from "@/vue/Public/event/SideBar.vue";
import Main from "@/vue/Public/event/Main.vue";
import {nextTick, onMounted, ref} from "vue";

const props = defineProps({
    categories: {
        type: [Array, Object, null],
        default: [],
    }
})

const loadLocation = ref(false);
const location = ref([]);
const fetchEventsLocation = async () => {
        loadLocation.value = true
    try {
        await axios.get('/api/event/all/location').then((response) => {
            location.value = response.data
            console.log(response.data)
        })
    } catch (e) {
        console.error(e.message)
    } finally {
        loadLocation.value = false
    }
}

const loadEvents = ref(false);
const events = ref([]);
const fetchEvents = async () => {
    loadEvents.value = true
    try {
        await axios.get('/api/event/10').then((response) => {
            events.value = response.data.data
        })
    } catch (e) {
        console.error(e.message)
    } finally {
        loadEvents.value = false
    }
}
const filtersChanged = async (value) => {
    loadEvents.value = true
    try {
        await axios.post('/api/event/all/search-result',value).then((response) => {
            events.value = response.data.data
            console.log(events.value)
        })
    } catch (e) {
        console.error(e.message)
    } finally {
        loadEvents.value = false
    }
}
const filtersInitialize = () => {
    fetchEvents()
}
onMounted(() => {
    fetchEventsLocation()
    nextTick()
    fetchEvents()
})
</script>
